var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-list",
    [
      _c(
        "q-collapsible",
        {
          staticClass: "filter",
          attrs: {
            icon: "fas fa-filter",
            label: _vm.$t("filter"),
            opened: !_vm.$q.platform.is.mobile ? true : false
          }
        },
        [
          _c(
            "q-list",
            { attrs: { "no-border": "" } },
            [
              _c(
                "q-item",
                [
                  _c(
                    "q-item-main",
                    [
                      _c("q-search", {
                        attrs: {
                          placeholder: _vm.$t("search"),
                          icon: "fas fa-search",
                          debounce: 600
                        },
                        on: {
                          input: function($event) {
                            return _vm.changeFilter("search")
                          }
                        },
                        model: {
                          value: _vm.selected_search,
                          callback: function($$v) {
                            _vm.selected_search = $$v
                          },
                          expression: "selected_search"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "q-list",
            { attrs: { "no-border": "", link: "" } },
            [
              _c("q-list-header", [_vm._v(_vm._s(_vm.$t("areas")))]),
              _c(
                "q-item",
                { attrs: { tag: "label" } },
                [
                  _c(
                    "q-item-side",
                    [
                      _c("q-radio", {
                        attrs: { val: "all" },
                        on: {
                          input: function($event) {
                            return _vm.changeFilter("areas")
                          }
                        },
                        model: {
                          value: _vm.selected_areas,
                          callback: function($$v) {
                            _vm.selected_areas = $$v
                          },
                          expression: "selected_areas"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "q-item-main",
                    [
                      _c(
                        "q-item-tile",
                        {
                          staticClass: "text-weight-light",
                          attrs: { label: "" }
                        },
                        [_vm._v(_vm._s(_vm.$t("all_f")))]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._l(_vm.areas, function(area, index) {
                return _c(
                  "q-item",
                  { key: index, attrs: { tag: "label" } },
                  [
                    _c(
                      "q-item-side",
                      [
                        _c("q-radio", {
                          attrs: { val: area.value },
                          on: {
                            input: function($event) {
                              return _vm.changeFilter("areas")
                            }
                          },
                          model: {
                            value: _vm.selected_areas,
                            callback: function($$v) {
                              _vm.selected_areas = $$v
                            },
                            expression: "selected_areas"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "q-item-main",
                      [
                        _c(
                          "q-item-tile",
                          {
                            staticClass: "text-weight-light",
                            attrs: { label: "" }
                          },
                          [_vm._v(_vm._s(area.label))]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              })
            ],
            2
          ),
          _vm.tags.length > 0
            ? _c(
                "q-list",
                { attrs: { "no-border": "", link: "" } },
                [
                  _c("q-list-header", [_vm._v(_vm._s(_vm.$t("tags")))]),
                  _vm._l(_vm.tags, function(tag, index) {
                    return _c(
                      "q-item",
                      { key: index, attrs: { tag: "label" } },
                      [
                        _c(
                          "q-item-side",
                          [
                            _c("q-checkbox", {
                              attrs: { val: tag.value },
                              on: {
                                input: function($event) {
                                  return _vm.changeFilter("tags")
                                }
                              },
                              model: {
                                value: _vm.selected_tags,
                                callback: function($$v) {
                                  _vm.selected_tags = $$v
                                },
                                expression: "selected_tags"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "q-item-main",
                          [
                            _c(
                              "q-item-tile",
                              {
                                staticClass: "text-weight-light",
                                attrs: { label: "" }
                              },
                              [_vm._v(_vm._s(tag.label))]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  })
                ],
                2
              )
            : _vm._e(),
          _c(
            "q-list",
            { attrs: { "no-border": "", link: "" } },
            [
              _c(
                "q-item",
                [
                  _c("q-item-main", [
                    _c("p", { staticClass: "text-center" }, [
                      _c(
                        "a",
                        {
                          staticClass: "text-faded",
                          attrs: { href: "#" },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.clearFilters()
                            }
                          }
                        },
                        [
                          _c("q-icon", { attrs: { name: "far fa-trash-alt" } }),
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("clear_filters")) +
                              "\n                        "
                          )
                        ],
                        1
                      )
                    ])
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }